import { useEffect, useState } from 'react'

// 裝置目前是否為直向（純視覺判斷，不涉及旋轉鎖定），用於直向時切換成強制橫向的全螢幕版面
export function usePortraitOrientation() {
  const [isPortrait, setIsPortrait] = useState(() => window.matchMedia('(orientation: portrait)').matches)

  useEffect(() => {
    const mql = window.matchMedia('(orientation: portrait)')
    const handler = (e) => setIsPortrait(e.matches)
    mql.addEventListener('change', handler)
    return () => mql.removeEventListener('change', handler)
  }, [])

  return isPortrait
}

// 是否為觸控裝置（粗指標），用於決定是否顯示 hover 專用互動
export function useIsTouchDevice() {
  const [isTouch, setIsTouch] = useState(() => window.matchMedia('(pointer: coarse)').matches)

  useEffect(() => {
    const mql = window.matchMedia('(pointer: coarse)')
    const handler = (e) => setIsTouch(e.matches)
    mql.addEventListener('change', handler)
    return () => mql.removeEventListener('change', handler)
  }, [])

  return isTouch
}
